import { Card, Skeleton } from "@/components/ui";

/** Mirrors `StoreCard`: banner, the avatar overlapping it, then name, tagline and stats. */
export function StoreCardSkeleton() {
  return (
    <Card padded={false} className="overflow-hidden" aria-hidden="true">
      <Skeleton className="aspect-16/5 w-full !rounded-none" />
      <div className="px-4 pb-4">
        <div className="relative -mt-6 mb-2 flex items-end justify-between">
          <Skeleton className="size-12 !rounded-full ring-3 ring-surface-2" />
          <Skeleton className="h-8 w-20" />
        </div>
        <Skeleton className="h-5 w-2/5" />
        <Skeleton className="mt-1.5 h-4 w-4/5" />
        <Skeleton className="mt-2 h-3 w-3/5" />
      </div>
    </Card>
  );
}
